import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { Button } from "@/components/ui/button";
import { REACTIONS } from "@/components/board/ReactionBar";

export default function DecisionsDigest() {
  const { data, loading } = useFetch("/decisions");
  useEffect(() => { if (data?.unseen) api.post("/decisions/seen").catch(() => {}); }, [data]);
  if (loading || !data) return null;
  return (
    <section className="mb-12 rounded-2xl border bg-card p-6" data-testid="decisions-digest">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><p className="eyebrow">Client decisions</p><p className="mt-1 text-sm text-muted-foreground">{data.items.length === 0 ? "No client feedback yet. Clients can react to any item on their board." : `${data.unseen} new since you last looked`}</p></div>
        <div className="flex gap-2">{Object.entries(REACTIONS).map(([v, R]) => <span key={v} className={`flex items-center gap-1 rounded-full px-2.5 py-1 text-xs ${R.cls}`} data-testid={`decisions-count-${v}`}><R.icon className="h-3 w-3" />{data.counts[v]}</span>)}</div>
      </div>
      {data.items.length > 0 && (
        <ul className="mt-5 divide-y" data-testid="decisions-list">
          {data.items.slice(0, 8).map((r) => { const R = REACTIONS[r.value]; return (
            <li key={r.id} className={`flex flex-wrap items-center gap-3 py-3 text-sm ${r.seen ? "" : "font-medium"}`} data-testid={`decision-${r.id}`}>
              <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${R.cls}`}><R.icon className="h-3.5 w-3.5" /></span>
              <span className="min-w-0 flex-1 truncate"><span>{r.user_name}</span> <span className="text-muted-foreground">· {R.label.toLowerCase()} ·</span> {r.element_label}{r.note && <span className="block truncate text-xs font-normal text-muted-foreground">“{r.note}”</span>}</span>
              <Button asChild variant="ghost" size="sm" data-testid={`decision-open-${r.id}`}><Link to={`/projects/${r.project_id}?tab=board`}>{r.project_name} <ArrowUpRight className="ml-1 h-3.5 w-3.5" /></Link></Button>
            </li>
          ); })}
        </ul>
      )}
    </section>
  );
}
